import { Field } from 'formik';
import { BaseSelect } from '../BaseSelect/BaseSelect';

/**
 * A select field that displays as single-select but stores value as an array
 * Useful when backend expects array format but UI should only allow one selection
 */
export const SingleSelectArrayField = ({
  name,
  label,
  options,
  customKeys = { label: 'name', value: 'id' },
  placeholder = '',
  popupClassName = '',
  allowClear = false,
  valueType = null,
  getPopupContainer = null,
}) => (
  <Field name={name}>
    {({ field, form }) => {
      // Extract single value from array for display
      const displayValue = Array.isArray(field.value) && field.value.length > 0
        ? field.value[0]
        : undefined;

      // Handle change: wrap single value back into array
      const handleChange = (value) => {
        const arrayValue = value !== undefined && value !== null ? [value] : [];
        form.setFieldValue(name, arrayValue);
      };

      // Handle blur to trigger validation
      const handleBlur = () => {
        form.setFieldTouched(name, true);
      };

      return (
        <BaseSelect
          field={{ ...field, value: displayValue }}
          form={form}
          label={label}
          placeholder={placeholder}
          selectOptions={options}
          customKeys={customKeys}
          data-testid={name}
          classNames={{ popup: { root: popupClassName || name } }}
          allowClear={allowClear}
          valueType={valueType}
          popupMatchSelectWidth={false}
          mode="default"
          getPopupContainer={getPopupContainer}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      );
    }}
  </Field>
);

export default SingleSelectArrayField;
